import React, { PureComponent } from "react";
import styled from "styled-components";

const UserUl = styled.ul`
  display: block;
  width: ${(props) => props.width || "33.33%"};
  padding: ${(props) => props.padding || "0 40px"};
  box-sizing: border-box;
`;
const UserOnlyText = styled.li`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "18px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  line-height: 26px;
  ${({ theme }) => theme.media.mobile`
    line-height: 15px;
  font-size: 10px
    `}
`;
const UserSpan = styled.span`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "0px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  margin: ${(props) => props.margin || "inherit"};
  position: ${(props) => props.position || "static"};
  ${({ theme }) => theme.media.mobile`
  font-size: 10px
    `}
`;

export class LocationAgreement2 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제2조 이용약관의 효력 및 변경
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            이 약관에서 사용하는 용어의 정의는 다음과 같다. 본 조에 의하여
            정의되지 않은 이 약관상의 용어의 의미는 일반적인 거래관행에 따른다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            본 약관은 개인위치정보주체가 본 약관 및 개별서비스 이용약관에
            동의하고, 서비스 이용을 위한 회원가입을 한 경우에 효력이 발생한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            개인위치정보주체가 앱 가입 시 본 약관에 대한 동의하기 버튼을
            클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며,
            그 적용에 동의한 것으로 본다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            매장이란, 서비스가맹점이 운영·관리하고 있는 사업체를 의미한다.회사는
            위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법,
            전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법 약관의
            규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을
            개정할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            회사가 약관을 개정할 경우에는 적용일자와 개정사유를 명시하여 현행
            약관과 함께 앱의 초기 화면에 공지하기로 한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            회사가 전항에 따라 개인위치정보주체에게 통지하였음에도,
            개인위치정보주체가 공지 또는 공지∙고지일로부터 개정약관 시행일 7일
            후까지 거부의사를 표시하지 아니하면 이용약관에 승인한 것으로 본다.
            개인위치정보주체가 개정약관에 동의하지 않을 경우 개인위치정보주체는
            이용계약을 해지할 수 있다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement3 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제3조 약관 외 준칙
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            본 약관에 명시되지 않은 사항은 위치정보의 보호 및 이용 등에 관한
            법률, 정보통신망 이용촉진 및 정보보호 등에 관한 법률,
            전기통신기본법, 전기통신사업법 등 관계법령과 회사의 이용약관 및
            개인정보처리방침, 회사가 별도로 정한 지침 등에 의한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement4 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제4조 서비스 내용 및 이용요금
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 회원의 위치정보를 직접 수집하거나 위치정보사업자로부터
            위치정보를 전달받아 아래와 같은 위치기반서비스를 제공한다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                위치정보를 활용한 검색결과 제공 서비스 : 정보 검색을 요청하거나
                개인위치정보주체 또는 이동성 있는 기기의 위치정보를 제공 시 본
                위치정보를 이용한 검색결과 및 주변결과(제휴 매장 등)를 제시
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                이용자 위치를 활용한 광고정보 제공: 검색결과 또는 기타 서비스
                이용 과정에서 개인위치정보주체 또는 이동성 있는 기기의 위치를
                이용하여 광고소재를 제시
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            제1항의 위치기반서비스의 이용요금은 기본적으로 무료이다. 단, 별도의
            유료 서비스의 경우 해당 서비스에 명시된 요금을 지불하여야 사용이
            가능하다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement5 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제5조 개인위치정보주체의 권리
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            개인위치정보주체는 개인위치정보의 수집 범위, 개인위치정보의
            이용ㆍ제공 목적, 제공받는 자의 범위 및 위치기반서비스의 일부에
            대하여 동의를 유보할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            개인위치정보주체는 언제든지 개인위치정보의 수집ㆍ이용ㆍ제공에 대한
            동의의 전부 또는 일부를 철회할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              3.
            </UserSpan>
            개인위치정보주체는 언제든지 개인위치정보의 수집ㆍ이용ㆍ제공의
            일시적인 중지를 요구할 수 있다. 이 경우 회사는 요구를 거절하지
            아니하며, 이를 위한 기술적 조치를 취한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              4.
            </UserSpan>
            개인위치정보주체는 회사에 대하여 아래 자료의 열람 또는 고지를 요구할
            수 있고, 당해 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있다.
            이 경우 회사는 정당한 이유 없이 요구를 거절하지 않는다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                개인위치정보주체에 대한 위치정보 수집ㆍ이용ㆍ제공 사실 확인자료
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                개인위치정보주체의 개인위치정보가 위치정보의 보호 및 이용 등에
                관한 법률 또는 다른 법령의 규정에 의하여 제3자에게 제공된 이유
                및 내용
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              5.
            </UserSpan>
            회사는 개인위치정보주체가 동의의 전부 또는 일부를 철회한 경우에는
            지체 없이 수집된 개인위치정보 및 위치정보 수집ㆍ이용ㆍ제공사실
            확인자료를 파기한다. 단, 동의의 일부를 철회하는 경우에는 철회하는
            부분의 개인위치정보 및 위치정보 수집ㆍ이용ㆍ제공사실 확인자료에
            한한다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              6.
            </UserSpan>
            개인위치정보주체는 회사에서 정한 절차에 따라 제1항 내지 제4항의
            권리를 행사할 수 있다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement6 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제6조 위치정보 이용ㆍ제공사실 확인자료 보유근거 및 보유기간
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에
            근거하여 개인위치정보주체에 대한 위치정보 수집ㆍ이용ㆍ제공사실
            확인자료를 위치정보시스템에 자동으로 기록하며, 1년 간 보관한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement7 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제7조 서비스의 변경 및 중지
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 위치정보사업자의 정책변경, 회사의 제반 사정 또는 법률상의
            장애 등으로 서비스를 유지할 수 없는 경우, 서비스의 전부 또는 일부를
            제한, 변경하거나 중지할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            제1항에 의한 서비스 중단의 경우, 회사는 이를 미리 앱에 공지하거나
            개인위치정보주체에게 통지한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement8 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제8조 개인위치정보 제3자 제공 시 즉시 통보
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 개인위치정보주체의 동의 없이 당해 개인위치정보주체의
            개인위치정보를 제3자에게 제공하지 아니하며, 제3자 제공 서비스를
            제공하는 경우에는 제공받는 자 및 제공목적을 사전에
            개인위치정보주체에게 고지하고 동의를 받는다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 개인위치정보를 개인위치정보주체가 지정하는 제3자에게 제공하는
            경우에는 개인위치정보를 수집한 당해 통신단말장치로 매회
            개인위치정보주체에게 제공받는 자, 제공일시 및 제공목적을 즉시
            통지한다. 다만, 아래에 해당하는 경우에는 개인위치정보주체가 미리
            특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통지한다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의
                수신기능을 갖추지 아니한 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                개인위치정보주체가 개인위치정보를 수집한 당해 통신단말장치 외의
                통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한
                경우
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement9 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제9조 손해배상
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사가 위치정보의 보호 및 이용 등에 관한 법률 제15조 내지 제26조의
            규정을 위반한 행위로 개인위치정보주체에게 손해가 발생한 경우,
            개인위치정보주체는 회사에 대하여 손해배상 청구를 할 수 있다. 이 경우
            회사는 고의, 과실이 없음을 입증하지 못한다면 책임을 면할 수 없다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            개인위치정보주체가 본 약관의 규정을 위반하여 회사에 손해가 발생한
            경우, 회사는 개인위치정보주체에 대하여 손해배상을 청구할 수 있다. 이
            경우 개인위치정보주체는 고의, 과실이 없음을 입증하지 못한다면 책임을
            면할 수 없다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement10 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제10조 면책
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여
            개인위치정보주체에게 발생한 손해에 대해서는 책임을 부담하지 않는다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  a.
                </UserSpan>
                천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  b.
                </UserSpan>
                서비스 제공을 위하여 회사와 서비스 제휴계약을 체결한 제3자의
                고의적인 서비스 방해가 있는 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  c.
                </UserSpan>
                개인위치정보주체의 귀책사유로 서비스 이용에 장애가 있는 경우
              </UserOnlyText>
              <UserOnlyText>
                <UserSpan margin="0 12px 0 -25px" position="absolute">
                  d.
                </UserSpan>
                제1호 내지 제3호를 제외한 기타 회사의 고의∙과실이 없는 사유로
                인한 경우
              </UserOnlyText>
            </UserUl>
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사는 서비스 및 서비스에 게재된 정보, 자료, 사실의 신뢰도, 정확성
            등에 대해서는 보증을 하지 않으며 이로 인해 발생한 개인위치정보주체의
            손해에 대하여는 책임을 부담하지 않는다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement11 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제11조 분쟁의 조정
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              1.
            </UserSpan>
            회사는 위치정보와 관련된 분쟁에 대하여 개인위치정보주체와 협의가
            이루어지지 아니하거나 협의를 할 수 없는 경우에는 방송통신위원회에
            재정을 신청할 수 있다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              2.
            </UserSpan>
            회사 또는 개인위치정보주체는 위치정보와 관련된 분쟁에 대해 당사자간
            협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는
            개인정보보호법에 따라 개인정보분쟁조정위원회에 조정을 신청할 수
            있다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement12 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제12조 규정의 운용
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            본 약관은 대한민국법령에 의하여 규정되고 이행되며, 본 약관에
            규정되지 않은 사항에 대해서는 관련법령 및 상관습에 의한다.
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement13 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          제13조 사업자 정보
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            회사의 상호, 주소, 전화번호 그 밖의 연락처는 다음과 같다.
          </UserOnlyText>
          <UserOnlyText>상호: 주식회사 랩포인트</UserOnlyText>
          <UserOnlyText>
            주소: 서울특별시 강서구 마곡동 757-3, 1117호
          </UserOnlyText>
          <UserOnlyText>전화번호 : 070-7543-2541</UserOnlyText>
          <UserOnlyText>이메일 주소 : wingardium@lab254.com</UserOnlyText>
        </UserUl>
      </div>
    );
  }
}

export class LocationAgreement14 extends PureComponent {
  render() {
    return (
      <div>
        <UserSpan
          color="#1e1e1e"
          fontSize="16px"
          fontWeight="bold"
          paddingTop="40px"
        >
          부칙
        </UserSpan>
        <UserUl width="100%" padding="0 0 0 25px">
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              제1조 시행일
            </UserSpan>
            본 약관은 2021년 8월 25일부터 적용된다.
          </UserOnlyText>
          <UserOnlyText>
            <UserSpan margin="0 12px 0 -25px" position="absolute">
              제2조 위치정보관리 책임자 정보
            </UserSpan>
            회사는 다음과 같이 위치정보 관리책임자를 지정하여 이용자들이 서비스
            이용과정에서 발생한 민원사항 처리를 비롯하여 개인위치정보주체의 권리
            보호를 위해 힘쓴다.
            <UserUl width="100%" padding="0 0 0 25px">
              <UserOnlyText>
                위치정보 관리책임자 : (개인)정보보호 담당자(개인정보 보호책임자
                겸직)
              </UserOnlyText>
              <UserOnlyText>전화번호 : 070-7543-2541</UserOnlyText>
              <UserOnlyText>이메일 주소 : wingardium@lab254.com</UserOnlyText>
            </UserUl>
          </UserOnlyText>
        </UserUl>
      </div>
    );
  }
}
